import { ECHARTSCOLOR as ECHARTS_COLORS } from '@/pages/intelligence/utils/echartsConst';
import type {
  IEChartOption,
  ILegendComponentOption,
  IXAxisOption,
  IYAxisOption,
  IArrayable,
} from '@/pages/intelligence/types/echart';

export const ECHART_DOWNLOAD_LOGO =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NzAuNjA3IiBoZWlnaHQ9IjEyOC41NTUiIHZpZXdCb3g9IjAg' +
  'MCA1NzAuNjA3IDEyOC41NTUiPg0KICA8ZyBpZD0i57uEXzE3NzU4IiBkYXRhLW5hbWU9Iue7hCAxNzc1OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI0OC40NjkgLTExMi41MDcpIj4NCiAgICA8cGF0aCBpZD0i6IGU5ZCIXzEiIG' +
  'RhdGEtbmFtZT0i6IGU5ZCIIDEiIGQ9Ik05MTUuMTQ1LTI2NzUuNjU3di0xNC45NjhhNTUuMTQzLDU1LjE0MywwLDAsMS0yMi40NTItNy40ODNsLTcuNDg0LDcuNDgzLTcuNDg0LTcuNDgzLDcuNDg0LTcuNDg1Yy00LjE3Mi0zLjkx' +
  'Ny0xMi4wMTUtMi41NDctMTQuOTY5LTcuNDg0bDE0Ljk2OS0xNC45NjhjNy42MzcsMTIuODYsMjEuMzY0LDIyLjQ1MiwzNy40MiwyMi40NTIsMTYuMDc4LDAsMjkuNzktOS41NjIsMzcuNDItMjIuNDUybDE0Ljk2OCw3LjQ4NGMtMy4' +
  'wMjUsNS4wODMtMy4xNzQsMTAuOTY0LTcuNDg0LDE0Ljk2OGw3LjQ4NCw3LjQ4NS03LjQ4NCw3LjQ4My0xNC45NjgtNy40ODNhNTIuOTA3LDUyLjkwNywwLDAsMS0yMi40NTIsNy40ODN2MTQuOTY4Wm00NDguNzc0LTM3LjN2LTU5L' +
  'jYwNmgxNS42ODZ2NTkuNjA2Wm01Mi42NTctLjEyMy0xNC45NjgtMjkuOTM2djI5LjkzNmgtMTQuOTY4di01OS44NzJoMTQuOTY4bDE0Ljk2OCwyOS45Mzd2LTI5LjkzN2gxNC45Njl2NTkuODcyWm0tNjcuMzU2LDAtNy40ODUtNy40' +
  'ODNoLTE0Ljk2OHY3LjQ4M0gxMzExLjhsMTQuOTY4LTU5Ljg3MmMuODcxLTIuOTU4LDQuMzUzLDAsNy40ODQsMGg3LjQ4NGwxNC45NjksNTkuODcyWm0tMTQuOTY5LTIyLjQ1Mmg3LjQ4NGwtNy40ODQtMTQuOTY4Wm0tMzcuNDE4LD' +
  'IyLjQ1Mi03LjQ4NC0yMi40NTFoLTcuNDg0djIyLjQ1MUgxMjY2Ljl2LTU5Ljg3MmgyOS45MzdjMy45MTUsMCw3LjQ4NC0zLjY1Myw3LjQ4NCwwdjI5LjkzN2E3Ljk4LDcuOTgsMCwwLDEtNy40ODQsNy40ODRsNy40ODQsMjIuNDUxW' +
  'm0tMTQuOTY5LTI5LjkzNmgxNC45Njl2LTIyLjQ1MmgtMTQuOTY5Wm0tNjcuMzU3LDI5LjkzNnYtNTkuODcyaDI5LjkzNnYyMi40NTJoNy40ODVhNy45MTMsNy45MTMsMCwwLDEsNy40ODQsNy40ODR2MjIuNDUyYTcuNjU5LDcuNjU5' +
  'LDAsMCwxLTcuNDg0LDcuNDgzWm0xNC45NjgtNy40ODNoMTQuOTY4di0xNC45NjloLTE0Ljk2OFptMC0yOS45MzdoNy40ODR2LTE0Ljk2OGgtNy40ODRabS0zNy40MiwzNy40MnYtNy40ODNoLTE0Ljk2OGwtNy40ODQsNy40ODNoLTc' +
  'uNDg0bDE0Ljk2OC01OS44NzJjLjg2OS0yLjk1OCw0LjM1MiwwLDcuNDg0LDBoNy40ODRsMTQuOTY4LDU5Ljg3MlptLTE0Ljk2OC0yMi40NTJoMTQuOTY4bC03LjQ4NC0xNC45NjhabS00NC45LDIyLjQ1MnYtNTIuMzg4aC0xNC45Nj' +
  'h2LTcuNDg0aDQ0Ljl2Ny40ODRoLTE0Ljk2OXY1Mi4zODhabS0yOS45MzUsMHYtNy40ODNIMTA3OS44djcuNDgzaC0xNC45NjlsMjIuNDUyLTU5Ljg3Mmg3LjQ4NGwyMi40NTIsNTkuODcyWm0tMTQuOTY5LTIyLjQ1Mmg3LjQ4NFYtM' +
  'jc1MC41Wm0tNjcuMzU4LTM3LjQyaDM3LjQyMWMzLjU2NywwLDcuNDg0LTMuMzA2LDcuNDg0LDB2NTIuMzg5YzAsMS40MjYtMS40MzMuOTEzLTMuMjg0LjRhOC43MjYsOC43MjYsMCwwLDAtNC4yLS40bC0zNy40MjEsNy40ODNabTE0' +
  'Ljk2OSw0NC45aDE0Ljk2OHYtMzcuNDJIMTAzNC44OVptLTEwNC43NzcsNy40ODRIOTE1LjE0NXY3LjQ4M2wtMTQuOTY4LTcuNDgzLTcuNDg0LTIyLjQ1MiwxNC45NjgtMjkuOTM3LDcuNDg0LTcuNDg0LDcuNDg0LDE0Ljk2OGg3LjQ4' +
  'M3YtMTQuOTY4bDE0Ljk2OSw3LjQ4NCw3LjQ4NCwyOS45Mzd2MjIuNDUybC0yMi40NTIsNy40ODNabTQ0LjktMTQuOTY4LTcuNDg0LTE0Ljk2OUg5NjAuMDVsLTcuNDg0LTIyLjQ1MnYtNy40ODRjLS4wNS0uMDQ3LS4wMjUtLjAyNSw' +
  'wLDB2LTIyLjQ1YzkuODQsNS4xNiwxNi42NDUsMTMuMDQsMjIuNDUyLDIyLjQ1MnY3LjQ4NGw3LjQ4NCw3LjQ4NGMxLjU2Niw1LjQyNSwwLDkuMDM5LDAsMTQuOTY4LDAsNi43MjQsMS45OTQsMTYuNCwwLDIyLjQ1MlpNODYyLjc1N' +
  'y0yNzUwLjVjMC01LjgzNC0xLjUxNy05LjYxOSwwLTE0Ljk2OGg3LjQ4M3YtMTQuOTY4YzUuOC05LjQ1NSwxMi41OTUtMTcuMjY1LDIyLjQ1Mi0yMi40NTJsNy40ODQsMTQuOTY4LTcuNDg0LDcuNDg0LDcuNDg0LDcuNDg0TDg4NS4y' +
  'MDktMjc1MC41aC03LjQ4NHYxNC45NjlsLTE0Ljk2OCw3LjQ4NEM4NjAuNzEzLTI3MzQuMTczLDg2Mi43NTctMjc0My42ODMsODYyLjc1Ny0yNzUwLjVabTEwNC43NzYsMHYwWm0tODkuODA4LDBabTM2Ni43MTgtMjIuNDUyQzEyNDQ' +
  'uNDQzLTI3NzYuNzc2LDEyNDguMjcxLTI3NzIuOTQ5LDEyNDQuNDQzLTI3NzIuOTQ5Wm0tMTU3LjE2NCwwQzEwODQuMTQ4LTI3NzIuOTQ5LDEwODguMTUtMjc3NS45MDcsMTA4Ny4yNzktMjc3Mi45NDlaIiB0cmFuc2Zvcm09InRyYW5' +
  'zbGF0ZSgtNjEyLjk3IDI5MTYuMjE5KSIgZmlsbD0iIzNjN2JmZiIgc3Ryb2tlPSJyZ2JhKDAsMCwwLDApIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMSIvPg0KICA8L2c+DQo8L3N2Zz4NCg==';

export const ECHART_DOWNLOAD_LOGO_BLACK =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDQuNzkiIGhlaWdodD0iMTIxLjY2NyIgdmlld0JveD0iMCAwIDU0NC' +
  '43OSAxMjEuNjY3Ij4NCiAgPGcgaWQ9Iue7hF8xNzc2NSIgZGF0YS1uYW1lPSLnu4QgMTc3NjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNDguODc5IC02OCkiPg0KICAgIDxnIGlkPSLnu4RfMTc3NTciIGRhdGEtbmFtZT0i57uEID' +
  'E3NzU3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDkgNjgpIj4NCiAgICAgIDxwYXRoIGlkPSLot6/lvoRfMTEiIGRhdGEtbmFtZT0i6Lev5b6EIDExIiBkPSJNMTE1LjI1Nyw0MTUuNjg5bC03LjE1Ny03LjE1Ny03LjE1Ny0xNC4zMT' +
  'RIOTMuNzg3TDg2LjYzLDM3Mi43NDh2LTcuMTU3Yy0uMDk1LS4wOTEuMS4wODksMCwwaDBWMzQ0LjEyMWM5LjQwOSw0LjkzNSwxNS45MTYsMTIuNDcsMjEuNDcxLDIxLjQ3MXY3LjE1N2w3LjE1Nyw3LjE1N2gwYzEuNSw1LjE4OCwwLDg' +
  'uNjQ0LDAsMTQuMzE0LDAsNi40MywxLjkwNywxNS42NzgsMCwyMS40N004Ni42Myw0MjIuODQ2LDY1LjE1OSw0MzB2LTcuMTU3SDUwLjg0NVY0MzBsLTE0LjMxNC03LjE1Ny03LjE1Ny0yMS40NzEsMTQuMzE0LTI4LjYyNyw3LjE1Ny03' +
  'LjE1N0w1OCwzNzkuOTA1aDcuMTU3VjM2NS41OTJsMTQuMzE0LDcuMTU3LDcuMTU3LDI4LjYyN1pNMjkuMzc1LDM2NS41OTJoMGw3LjE1Nyw3LjE1N0wyMi4yMTgsMzk0LjIxOUgxNS4wNjF2MTQuMzE0TC43NDcsNDE1LjY4OWMtMS45N' +
  'TQtNS44NiwwLTE0Ljk1NSwwLTIxLjQ3LDAtNS41NzktMS40NS05LjIsMC0xNC4zMTRINy45VjM2NS41OTJjNS41NDgtOS4wNDIsMTIuMDQ0LTE2LjUxLDIxLjQ3MS0yMS40NzFsNy4xNTcsMTQuMzE0LTcuMTU3LDcuMTU3Wk03LjksND' +
  'MwbDE0LjMxNC0xNC4zMTRjNy4zLDEyLjMsMjAuNDMxLDIxLjQ3MSwzNS43ODQsMjEuNDcxLDE1LjM3NSwwLDI4LjQ4OC05LjE0NSwzNS43ODQtMjEuNDcxbDE0LjMxNCw3LjE1N2MtMi44OTMsNC44NjItMy4wMzUsMTAuNDg0LTcuMTU' +
  '3LDE0LjMxNGw3LjE1Nyw3LjE1Ny03LjE1Nyw3LjE1N0w4Ni42Myw0NDQuMzE3YTUwLjU4Nyw1MC41ODcsMCwwLDEtMjEuNDcxLDcuMTU3djE0LjMxNEg1MC44NDVWNDUxLjQ3NGE1Mi43MzMsNTIuNzMzLDAsMCwxLTIxLjQ3MS03LjE1' +
  'N2wtNy4xNTcsNy4xNTctNy4xNTctNy4xNTcsNy4xNTctNy4xNTdDMTguMjI5LDQzMy40MTUsMTAuNzI5LDQzNC43MjQsNy45LDQzMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMzQ0LjEyMSkiIGZpbGw9IiNkZGRlZTIiIGZpbGwt' +
  'cnVsZT0iZXZlbm9kZCIvPg0KICAgICAgPHBhdGggaWQ9Iui3r+W+hF8xMiIgZGF0YS1uYW1lPSLot6/lvoQgMTIiIGQ9Ik0yNzQuNzEzLDM5MS43MzVIMzEwLjVjMy40MTEsMCw3LjE1Ny0zLjE2MSw3LjE1NywwdjUwLjFjMCwyLjMyO' +
  'S00LS43NDktNy4xNTcsMGwtMzUuNzg0LDcuMTU3aDBabTI4LjYyOCw0Mi45NDFWMzk4Ljg5MUgyODkuMDI3djM1Ljc4NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjMuNjcyIC0zNjMuMTA3KSIgZmlsbD0iI2RkZGVlMiIvPg0KI' +
  'CAgICAgPHBhdGggaWQ9Iui3r+W+hF8xMyIgZGF0YS1uYW1lPSLot6/lvoQgMTMiIGQ9Ik0zNjUuODc2LDQ0MS43MDZ2Ny4xNTdIMzUxLjU2MmwyMS40Ny01Ny4yNTVjLjgzMi0yLjgyOC0yLjk5NCwwLDAsMGg3LjE1N2wyMS40NzEsN' +
  'TcuMjU1SDM4Ny4zNDZ2LTcuMTU3Wm0xNC4zMTQtMTQuMzE0VjQxMy4wNzhsLTcuMTU3LDE0LjMxNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTcuNTc5IC0zNjIuOTgpIiBmaWxsPSIjZGRkZWUyIi8+DQogICAgICA8cGF0aCBpZ' +
  'D0i6Lev5b6EXzE0IiBkYXRhLW5hbWU9Iui3r+W+hCAxNCIgZD0iTTQzOC44MTksMzk3LjY4M3YtNy4xNTdINDgxLjc2djcuMTU3SDQ2Ny40NDd2NTAuMUg0NTMuMTMzdi01MC4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5NC43M' +
  'zkgLTM2MS44OTgpIiBmaWxsPSIjZGRkZWUyIi8+DQogICAgICA8cGF0aCBpZD0i6Lev5b6EXzE1IiBkYXRhLW5hbWU9Iui3r+W+hCAxNSIgZD0iTTUyNi4yNDUsNDQxLjcwNmwtNy4xNTcsNy4xNTdoLTcuMTU3bDE0LjMxNC01Ny4yNT' +
  'VjLjgzMi0yLjgyOCw0LjE2MiwwLDcuMTU3LDBoNy4xNTdsMTQuMzE0LDU3LjI1NUg1NDAuNTU4di03LjE1N1ptMTQuMzE0LTE0LjMxNEw1MzMuNCw0MTMuMDc4bC03LjE1NywxNC4zMTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMj' +
  'I0LjkwOSAtMzYyLjk4KSIgZmlsbD0iI2RkZGVlMiIvPg0KICAgICAgPHBhdGggaWQ9Iui3r+W+hF8xNiIgZGF0YS1uYW1lPSLot6/lvoQgMTYiIGQ9Ik02NDkuNzM5LDQyMC41NTN2MjEuNDcxYTcuMzI1LDcuMzI1LDAsMCwxLTcuMT' +
  'U3LDcuMTU3SDYwNi44VjM5MS45MjVoMjguNjI3YzMuNjYsMCwwLTMuNjYsMCwwVjQxMy40aDcuMTU3YTcuNTY3LDcuNTY3LDAsMCwxLDcuMTU3LDcuMTU3bS0yMS40NzEtMjEuNDcxaC03LjE1N1Y0MTMuNGg3LjE1N1ptNy4xNTcsMjg' +
  'uNjI4SDYyMS4xMTJ2MTQuMzE0aDE0LjMxM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNjkuNjc4IC0zNjMuMjk4KSIgZmlsbD0iI2RkZGVlMiIvPg0KICAgICAgPHBhdGggaWQ9Iui3r+W+hF8xNyIgZGF0YS1uYW1lPSLot6/lvoQg' +
  'MTciIGQ9Ik02OTQuNzQ4LDQ0OS4xMTdWMzkxLjg2MmgyOC42MjdjMy43NDQsMCw3LjE1Ny0zLjQ5NCw3LjE1NywwdjI4LjYyN2E3LjYzMSw3LjYzMSwwLDAsMS03LjE1Nyw3LjE1N2gwbDcuMTU3LDIxLjQ3aC03LjE1N2wtNy4xNTctM' +
  'jEuNDdoLTcuMTU3djIxLjQ3Wm0yOC42MjctNTAuMUg3MDkuMDYxdjIxLjQ3MWgxNC4zMTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzA3LjUyOSAtMzYzLjIzNCkiIGZpbGw9IiNkZGRlZTIiLz4NCiAgICAgIDxwYXRoIGlkPSLot' +
  '6/lvoRfMTgiIGRhdGEtbmFtZT0i6Lev5b6EIDE4IiBkPSJNNzg2LjMyMyw0NDEuNzA2djcuMTU3SDc3Mi4wMDlsMTQuMzE0LTU3LjI1NWMuODMzLTIuODI4LDQuMTYzLDAsNy4xNTcsMGg3LjE1N2wxNC4zMTQsNTcuMjU1aC03LjE1N' +
  '2wtNy4xNTctNy4xNTdabTE0LjMxMy0xNC4zMTQtNy4xNTctMTQuMzE0djE0LjMxNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNDEuODUxIC0zNjIuOTgpIiBmaWxsPSIjZGRkZWUyIi8+DQogICAgICA8cmVjdCBpZD0i55+p5b2iX' +
  'zEiIGRhdGEtbmFtZT0i55+p5b2iIDEiIHdpZHRoPSIxNSIgaGVpZ2h0PSI1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDgwIDI5KSIgZmlsbD0iI2RkZGVlMiIvPg0KICAgICAgPHBhdGggaWQ9Iui3r+W+hF8xOSIgZGF0YS1uYW1lP' +
  'SLot6/lvoQgMTkiIGQ9Ik05NTEuOTgsNDQ3Ljc4MUg5MzcuNjY2bC0xNC4zMTQtMjguNjI3djI4LjYyN0g5MDkuMDM5VjM5MC41MjZoMTQuMzEzbDE0LjMxNCwyOC42MjdWMzkwLjUyNkg5NTEuOThaIiB0cmFuc2Zvcm09InRyYW5zb' +
  'GF0ZSgtNDA3LjMxMSAtMzYxLjg5OCkiIGZpbGw9IiNkZGRlZTIiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K';

// 图表grid距离顶部的距离（柱状图，柱子上不带数值显示）
export const BAR_GRID_TOP = 10;

// 图表grid距离顶部的距离（柱状图，柱子上带数值显示，要预留的空间多一点）
export const BAR_GRID_TOP_WITH_LABEL = 16;

// 图表grid距离顶部的距离（折线图）
export const LINE_GRID_TOP = 10;

// 图例距离底部的距离
export const LEGEND_BOTTOM = -4;

// x轴带富文本图片这种柱状图 的grid 的bottom值 16px为图例高度，14px为 图例与图表的留白高度（设计要求16px，但实际由于富文本游戏图片，名称 的高度无法精准控制，导致16px视觉效果跟20px一样了，所以这里按14px处理）
export const BAR_GRID_BOTTOM_WITH_RICH_IMG = 16 + 14;

// 图例配置
const LEGEND_OPTION: ILegendComponentOption = {
  type: 'scroll',
  orient: 'horizontal', // 横向
  pageIconColor: '#000', // 翻页箭头颜色
  selectedMode: true,
  pageIconSize: 12,
  pageTextStyle: {
    color: '#000', // 翻页数字颜色
  }, // 翻页数字设置
  show: true,
  icon: 'circle',
  itemWidth: 8,
  itemHeight: 8,
  bottom: 0,
  left: 'center',
  padding: [0, 5],
  textStyle: {
    color: '#888888',
    fontSize: 12,
    // padding: [0,10, 0,2],
  },
  itemGap: 20, // 图例之间间距20
};
// x轴配置
const X_AXIS_OPTION: IArrayable<IXAxisOption> = {
  type: 'category',
  data: [],
  axisTick: {
    alignWithLabel: true, // x轴刻度线与标签对齐
    lineStyle: {
      color: '#BFBFBF',
      // 透明度会展示到虚线，暂时用纯色代替
      // color: '#000',
      // opacity: 0.25,
      width: 1,
    },
  },
  boundaryGap: true,
  axisLabel: {
    // x轴文字样式
    color: '#000',
    align: 'center',
    opacity: 0.45,
    fontSize: 12,
    margin: 10,
  },
  axisLine: {
    show: true,
    onZero: false, // 当y轴有负数时,让x轴下落在y轴最小值
    lineStyle: {
      color: '#BFBFBF',
      // 透明度会展示到虚线，暂时用纯色代替
      // color: '#000',
      // opacity: 0.25,
      width: 1,
    },
  },
};
// y轴配置
const Y_AXIS_OPTION: IArrayable<IYAxisOption> = {
  type: 'value',
  splitNumber: 4,
  splitLine: {
    show: true,
    lineStyle: {
      type: 'dashed',
    },
  },
  axisLabel: {
    // y轴文字样式
    color: '#000',
    opacity: 0.45,
    fontSize: 12,
  },
};

// echarts总配置
export const STATIC_OPTION: IEChartOption = {
  color: ECHARTS_COLORS,
  tooltip: {
    trigger: 'axis',
    padding: 0,
    backgroundColor: 'rgba(0,0,0,0)',
  },
  grid: {
    left: 35,
    right: 20,
    top: 30,
    bottom: 12 + 10 + 15 + 8,
  },
  legend: LEGEND_OPTION,
  xAxis: X_AXIS_OPTION,
  yAxis: Y_AXIS_OPTION,
  series: [],
  dataset: {
    dimensions: [],
    source: [],
  },
};
